import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
    & > div > div > div > div > div > table > tbody > tr > td > span:before {
        content: "";
    }

    @media screen and (max-width: 992px) {
        & > div > div > div > div > div > table {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-thead {
            display: none;
        }
        & > div > div > div > div > div > table > .ant-table-tbody {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-tbody > .ant-table-row {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
        &
            > div
            > div
            > div
            > div
            > div
            > table
            > .ant-table-tbody
            > .ant-table-row
            > .ant-table-cell {
            border-bottom: 1px solid #f0f0f0;
            padding: 6px 16px !important;
            width: 100%;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span:before {
            content: attr(data-label);
            font-weight: bold;
            padding-right: 5px;
        }
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const StyledVariationList = styled.div`
    min-width: 200px;
    max-height: 400px;
    overflow-y: auto;
    padding: 8px 0;

    /* Scrollbar stilleri */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.3);
        border-radius: 3px;

        &:hover {
            background: rgba(255, 255, 255, 0.5);
        }
    }
`;

export const VariationItem = styled.div`
    padding: 8px 12px;
    margin: 4px 0;
    background: #000;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-left: 3px solid rgba(255, 255, 255, 0.3);

    &:hover {
        background: #000;
    }
`;

export const VariationDetail = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .label {
        font-weight: 500;
        opacity: 1.2;
        margin-right: 8px;
    }

    .value {
        font-weight: 600;
    }
`;
